import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { SurveyEvent } from './survey_events';

@Injectable({ providedIn: 'root' })
export class SurveyEventProvider extends DomainEventProvider<SurveyEvent> {}
